import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { Point } from '@/domain/dienstplan/features/VisualEditor/types';

export function getMousePosition(ctx: SharedContext, point: Point) {
  return {
    x: ctx.xScalePoint.invert(point.x),
    y: ctx.yScalePoint.invert(point.y),
  };
}
